import { useEffect, useState } from "react";
import { easeInOut, motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Components
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import colors from "../../constants/colors";
import * as Styles from './style'

//Assets
import arrow from "../../assets/icons/arrow_down.svg";

//actions
import { addSelectedAssetInfo, openAssetInput } from "../../redux/walletReducer";

//Placeholders
import noItemImage from "./../../assets/notFoundImages/No item found.png";

import { RootState } from "../../redux/store";
import axios from "axios";
import env from "../../constants/env";
import { shortenAddress } from "../../utils/shortenAddress";
import ProcessingModal from "../../components/ProcessingModal";
import { BodyRegular, BodySemibold, HealLine3 } from "../../shared/typography";
import { AnyAction } from "@reduxjs/toolkit";
import { Search } from "../../components/Search";
import Button from "../../components/Button";
import { Row } from "./style";
import HeroAnimation from "../Home/HeroAnimation";

function Assets() {
  const navigate = useNavigate();
  let wallet = useSelector((state: RootState) => state.walletState);
  let dispatch = useDispatch();

  const [userAssets, setUserAssets] = useState([]);
  const [filteredAssetsArr, setFilteredAssetsArr] = useState([]);

  const [searchKey, setSearchKey] = useState('');

  const [proxyTokenExistsData, setProxyTokenExistsData] = useState<any>();
  const [whiteListedArr, setWhiteListedArr] = useState([]);
  const [filteredWhiteListedArr, setFilteredWhiteListedArr] = useState([]);


  useEffect(() => {
    const route = window.location.pathname.split("/");
    if (
      !(
        route.length > 3 &&
        wallet.address != null &&
        (wallet.assetChain === "ETH" || wallet.assetChain === "POLIGON")
      )
    ) {
      // navigate(`/`);
    }
  }, []);

  useEffect(() => {
    if (!searchKey) return setFilteredAssetsArr(userAssets)
    const resultArr = userAssets?.filter((item: any) => {
      const regex = new RegExp(searchKey, 'i')
      return (regex?.test(item?.token_id) || regex?.test(`#${item?.token_id}`) || regex?.test(item?.token_metadata?.name))
    })
    setFilteredAssetsArr(resultArr)
  }, [searchKey]);

  const searchHandler = (val: string) => {
    setSearchKey(val)
  }

  // Fetch whitelisted assets
  const fetchWhiteListedAssets = useQuery({
    queryKey: ["whitelistedAssets"],
    queryFn: async () => {
      const whitelistedAssets = await axios.get(
        `${env.PUBLIC_URL}/fetchWhitelistedCollections`
      );
      return whitelistedAssets.data.filter(
        (item: any) => item.nft_asset_chain === wallet.assetChain
      );
    },
  });

  // Fetch User Assets after whitelisted assets are fetched
  let whitelistedAssets = fetchWhiteListedAssets?.data;
  localStorage.setItem('WHITE_LISTED_CONTRACTS', JSON.stringify(whitelistedAssets))
  const fetchUserAssets = useQuery({
    queryKey: ["userAssets", fetchWhiteListedAssets.isSuccess],
    queryFn: async () => {
      const queryUrl =
        "&token_addresses=" +
        fetchWhiteListedAssets.data
          .map((item: any) => item.nft_asset_contract_address)
          .join("&token_addresses=");

      const options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "X-API-Key": env.MORALIS_API_KEY,
        },
      };

      const userNfts = await axios.get(
        `${env.MORALIS_URL}/api/v2/${wallet.assetAddress}/nft?chain=${wallet.assetChain == "ETH" ? env.ETH_CHAIN : env.POLYGON_CHAIN
        }&format=decimal${queryUrl}`,
        options
      );
      console.log('userNfts', userNfts);

      const userNftsData = userNfts.data.result
        .filter((item: any) => {
          return item.metadata == null ? false : true;
        })
        .map((item: any) => {
          return {
            token_address: item.token_address,
            token_id: item.token_id,
            token_metadata: JSON.parse(item.metadata),
          };
        });
      return userNftsData;
    },
    enabled: fetchWhiteListedAssets.isSuccess && whitelistedAssets.length >= 0,
  });

  // let userAssets = fetchUserAssets?.data;
  // let whiteListedArr = fetchWhiteListedAssets?.data;

  const checkIfProxyTokenExists = async () => {
    const assets_to_check = userAssets.map((item: any) => {
      return {
        nft_asset_chain: wallet.assetChain,
        nft_asset_contract_address: item.token_address,
        nft_asset_id: item.token_id,
      };
    });
    const proxyTokenCheckData = await axios.post(
      `${env.PUBLIC_URL}/checkProxyTokenPresenceForMultipleAssets`,
      { tokens: assets_to_check }
    );

    console.log('proxyTokenCheckData', proxyTokenCheckData);
    if (proxyTokenCheckData?.data?.length === 0) return

    setProxyTokenExistsData(
      proxyTokenCheckData?.data?.filter((item: any) => item.status)
    );
  };

  useEffect(() => {
    setUserAssets(fetchUserAssets.data);
    setFilteredAssetsArr(fetchUserAssets.data)
    setWhiteListedArr(fetchWhiteListedAssets.data);
    setFilteredWhiteListedArr(fetchWhiteListedAssets.data);
  }, [fetchUserAssets.data, fetchWhiteListedAssets.data]);

  useEffect(() => {
    if (userAssets && userAssets.length > 0) {
      checkIfProxyTokenExists();
    }
  }, [userAssets]);

  const onNftClick = (
    token_id: string,
    token_address: string,
    token_metadata: any,
    proxyTokenExists = false
  ) => {
    dispatch(
      addSelectedAssetInfo({
        token_metadata: token_metadata,
        token_id: token_id,
        token_address: token_address,
        proxy_token_exists: proxyTokenExists,
      })
    );
    navigate(
      `/proxyTokenInit/${wallet.assetChain}/${wallet.assetAddress}/${token_address}/${token_id}?proxy_token_exists=${proxyTokenExists}`
    );
  };

  if (!userAssets?.length) {
    return (
      <>
        {
          fetchUserAssets.isLoading || fetchWhiteListedAssets.isLoading ? (
            <Styles.LoaderContainer>
              <ProcessingModal
                processingMessage="fetching assets from your asset wallet..."
                loaderHeading="Loading Data"
              />
            </Styles.LoaderContainer>
          )
            : (
              <Styles.ErrorContainer>
                <Nav />
                <AssetErrorComp chain={wallet.assetChain} />
              </Styles.ErrorContainer>
            )
        }
      </>

    )
  }

  return (
    <>
      <Styles.Container>
        <Nav />
        <HeroAnimation />
        <Styles.Wrapper>
          <span className="colSpan">
            <HealLine3>
              List of Assets{" "}
            </HealLine3>
            <div className="textContainer">
              <HealLine3>in wallet{" "}</HealLine3>
              <HealLine3 color={colors.INTERFACE_COLORS_DARK_STONE}>
                {shortenAddress(wallet.assetAddress ? wallet.assetAddress : "")}{" "}
                on {wallet.assetChain}{" "}
              </HealLine3>
            </div>
            <Search
              onChange={(e) => {
                searchHandler(e.target.value)
              }}
              value={searchKey}
              placeholder='Search...'
            />
            <span
              onClick={() => {
                navigate("/proxy-tokens-list");
              }}
              className="linkText"
            >
              View Proxy Tokens
            </span>
          </span>
          <Styles.AllNFTsContainer>
            {
              filteredWhiteListedArr.map((item: any, i: number) => {
                return (
                  <NftProject
                    key={item.nft_asset_contract_address}
                    collectionInfo={item}
                    userAssets={filteredAssetsArr.filter(
                      (asset: any) => {
                        return item.nft_asset_contract_address?.toLowerCase() === asset?.token_address?.toLowerCase()
                      }
                    )}
                    proxyTokenExistsData={
                      proxyTokenExistsData?.length
                        ? proxyTokenExistsData.filter(
                          (asset: any) =>
                            item?.nft_asset_contract_address?.toLowerCase() ===
                            asset?.asset_contract_address?.toLowerCase()
                        )
                        : []
                    }
                    defaultOpen={i == 0 ? true : false}
                    onNftClick={onNftClick}
                  />
                );
              })
            }

          </Styles.AllNFTsContainer>
        </Styles.Wrapper>
      </Styles.Container>
      <Footer />
    </>
  );
}

const NftProject = ({
  defaultOpen,
  collectionInfo,
  userAssets,
  proxyTokenExistsData,
  onNftClick,
}: {
  defaultOpen?: boolean;
  collectionInfo: any;
  userAssets: any;
  proxyTokenExistsData: any;
  onNftClick: any;
}) => {
  const [toggle, settoggle] = useState(defaultOpen);

  return (
    <Styles.MotionContainer
      initial={{
        height: "110px",
      }}
      animate={toggle ? { height: "max-content", } : {}}
      transition={{
        duration: 0.5,
        ease: easeInOut,
      }}
    >
      <Styles.SpanContainer
        onClick={() => {
          settoggle(!toggle);
        }}
      >
        <Styles.NFTGroupImage
          src={collectionInfo?.collection_image_url?.includes('ipfs://') ? `https://cf-ipfs.com/ipfs/${collectionInfo?.collection_image_url?.split('://')[1]}` : collectionInfo?.collection_image_url}
          alt=""
        />
        <span>
          <h2 className="collectionNameText">{collectionInfo.collection_name}</h2>
          <BodySemibold className="assetCountText">
            {userAssets.length} {userAssets.length > 1 ? "Items" : "Item"}
          </BodySemibold>
        </span>
        <Styles.ArrowContainer>
          <Row gap="24px">
            {proxyTokenExistsData?.length ? (
              <Styles.Dot />
            ) : <></>
            }
            <motion.img
              initial={{
                rotate: 0,
              }}
              animate={toggle ? { rotate: 180 } : {}}
              src={arrow}
              alt=""
            />
          </Row>
        </Styles.ArrowContainer>
      </Styles.SpanContainer>
      <Styles.NFTsListContainer>
        {userAssets.map(
          (item: any) => {
            return (
              <Nft
                key={item.token_id}
                token_id={item.token_id}
                token_address={item.token_address}
                token_metadata={item.token_metadata}
                onNftClick={onNftClick}
                collectionName={collectionInfo.collection_name}
                proxyTokenExists={
                  proxyTokenExistsData?.filter(
                    (asset: any) => asset.asset_id == item.token_id
                  ).length > 0
                }
              />
            );
          } /* <Nft /> */
        )}
      </Styles.NFTsListContainer>
    </Styles.MotionContainer>
  );
};

const Nft = ({
  token_id,
  token_address,
  token_metadata,
  onNftClick,
  proxyTokenExists,
  collectionName
}: {
  token_id: string;
  token_address: string;
  token_metadata: any;
  onNftClick: any;
  proxyTokenExists: boolean;
  collectionName: string
}) => {
  return (
    <Styles.NFTCardContainer
      onClick={() => {
        onNftClick(token_id, token_address, token_metadata, proxyTokenExists);
      }}
    >
      <Styles.NFTImage
        src={token_metadata?.image?.includes('ipfs://') ? `https://cf-ipfs.com/ipfs/${token_metadata?.image?.split('://')[1]}` : token_metadata?.image}
        loading="lazy"
        alt="NFT image"
      />
      <Styles.NFTCardDetails>
        {proxyTokenExists ? (
          <Styles.Dot />
        ) : <></>
        }{" "}
        <BodyRegular
          className="nftNameText"
        >
          {token_metadata.name || `${collectionName} #${token_id}`}
        </BodyRegular>
      </Styles.NFTCardDetails>
    </Styles.NFTCardContainer>
  );
};

const AssetErrorComp = ({ chain }: { chain: string }) => {
  let dispatch = useDispatch();
  return (
    <Styles.Col padding="100px 0 0 0" align="center">
      <Styles.ImageComp
        src={noItemImage}
        alt='no-asset-found'
      />
      <HealLine3>No item found in this wallet</HealLine3>
      <BodyRegular>You need to add items to your wallet</BodyRegular>
      <Button
        width={"300px"}
        type="YELLOW"
        onClick={() => {
          dispatch(openAssetInput() as any as AnyAction);
        }}
      >
        Update Asset Wallet
      </Button>
    </Styles.Col>
  )
};

export default Assets;
